import PublicOvertimeDetailContainerBody from './PublicOvertimeDetailContainerBody';

export default PublicOvertimeDetailContainerBody;
